import { api } from 'src/api/endpoints';
import {
  NOTIFICATIONS_FETCH_REQUEST,
  NOTIFICATIONS_FETCH_SUCCESS,
  NOTIFICATIONS_FETCH_FAIL,
  NOTIFICATIONS_MARK_READ,
  NOTIFICATIONS_MARK_ALL_READ,
  NOTIFICATIONS_DELETE,
  NOTIFICATIONS_CREATE,
} from '../constant';

export const fetchNotifications = (userRole) => async (dispatch) => {
  dispatch({ type: NOTIFICATIONS_FETCH_REQUEST });
  try {
    const minePromise = api.get('/notifications');
    const allPromise =
      userRole === 'admin'
        ? api.get('/notifications/all')
        : Promise.resolve({ data: { notifications: [] } });
    const [{ data: mine }, allResp] = await Promise.all([
      minePromise,
      allPromise,
    ]);
    dispatch({
      type: NOTIFICATIONS_FETCH_SUCCESS,
      payload: {
        notifications: Array.isArray(mine?.notifications)
          ? mine.notifications
          : [],
        allNotifications: Array.isArray(allResp?.data?.notifications)
          ? allResp.data.notifications
          : [],
      },
    });
  } catch (e) {
    dispatch({
      type: NOTIFICATIONS_FETCH_FAIL,
      payload: e?.response?.data?.error || 'Failed to load notifications',
    });
  }
};

export const markNotificationRead = (id) => async (dispatch) => {
  dispatch({ type: NOTIFICATIONS_MARK_READ, payload: id }); // optimistic
  try {
    await api.post(`/notifications/${id}/read`);
  } catch (e) {
    // refetch on failure to revert
    // (Could implement revert logic, simpler to refetch)
  }
};

export const markAllNotificationsRead = () => async (dispatch) => {
  dispatch({ type: NOTIFICATIONS_MARK_ALL_READ });
  try {
    await api.post('/notifications/read-all');
  } catch (e) {
    /* ignore */
  }
};

export const deleteNotification = (id) => async (dispatch) => {
  dispatch({ type: NOTIFICATIONS_DELETE, payload: id }); // optimistic
  try {
    await api.delete(`/notifications/${id}`);
  } catch (e) {
    /* ignore */
  }
};

export const createNotification =
  ({ targetType, content, userId }) =>
  async (dispatch) => {
    if (!content?.trim()) return;
    let endpoint = '/notifications/for-admin';
    let payload = { content: content.trim() };
    if (targetType === 'user') {
      endpoint = '/notifications/admin-to-user';
      payload = { content: content.trim(), userId: userId?.trim() };
    } else if (targetType === 'allUsers') {
      endpoint = '/notifications/for-users';
      payload = { content: content.trim() };
    }
    try {
      const { data } = await api.post(endpoint, payload);
      if (data?.notification) {
        dispatch({ type: NOTIFICATIONS_CREATE, payload: data.notification });
      }
    } catch (e) {
      throw e;
    }
  };
